import { useMemo, useState } from "react";
import { Gesture } from "react-native-gesture-handler";
import { runOnJS, SharedValue, useSharedValue, withSpring } from "react-native-reanimated";

const useInfiniteCarouselGesture = ({
	animatedIndex,
	setFocusedIndex,
	itemWidth,
	itemSpacing,
	numItems,
}: {
	animatedIndex: SharedValue<number>;
	setFocusedIndex: (index: number) => void;
	itemWidth: number;
	itemSpacing: number;
	numItems: number;
}) => {
	const [isMoving, setIsMoving] = useState(false);

	const startIndex = useSharedValue(0);
	const gesture = useMemo(() => {
		const width = itemWidth + itemSpacing;
		const halfNumItems = Math.floor(numItems / 2);
		return Gesture.Pan()
			.onStart(() => {
				"worklet";
				runOnJS(setIsMoving)(true);
				startIndex.value = animatedIndex.value;
			})
			.onChange((event) => {
				"worklet";
				animatedIndex.value = startIndex.value - event.translationX / width;
			})
			.onEnd((event) => {
				"worklet";
				const curAnimatedIndex = animatedIndex.value;
				const newIndex = Math.round(
					curAnimatedIndex -
						Math.max(
							Math.min((0.05 * event.velocityX) / width, halfNumItems),
							-halfNumItems,
						),
				);
				runOnJS(setFocusedIndex)(newIndex);
				animatedIndex.value = withSpring(
					newIndex,
					{
						velocity: -event.velocityX / width,
						damping: 30,
						mass: 0.8,
						stiffness: 300,
						restDisplacementThreshold: 0.001,
					},
					(didFinish) => {
						"worklet";
						if (didFinish) {
							runOnJS(setIsMoving)(false);
						}
					},
				);
			});
	}, [animatedIndex, itemSpacing, itemWidth, numItems, setFocusedIndex, startIndex]);

	return { gesture, isMoving };
};
export default useInfiniteCarouselGesture;
